// extracted by mini-css-extract-plugin
module.exports = {"container":"KnowledgeCenterBootcampItem_container__2mGlB","video":"KnowledgeCenterBootcampItem_video__1izwD"};